import React from 'react';

const Icon = () => (
  <g>
    <path
      d="M17.5 8L19 8C20.1046 8 21 8.89543 21 10L21 17C21 18.1046 20.1046 19 19 19L5 19C3.89543 19 3 18.1046 3 17L3 10C3 8.89543 3.89543 8 5 8L6.5 8"
      stroke="#D50000"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 9L12 3"
      stroke="#D50000"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 3L9.5 5"
      stroke="#D50000"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 3L14.5 5"
      stroke="#D50000"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="7" cy="13.5" r="0.5" fill="#1E2B37" stroke="#D50000" />
    <circle cx="17" cy="13.5" r="0.5" fill="#1E2B37" stroke="#D50000" />
    <circle cx="12" cy="13.5" r="1.5" stroke="#D50000" strokeWidth="2" />
  </g>
);

export default Icon;
